import "../css/MyOrders.css";
import axios from "axios";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

function MyOrders() {
  const shoppingCart = useSelector((state) => state.shoppingCart.content);
  const customer = useSelector((state) => state.customer);
  const [orders, setOrders] = useState([]);
  const [modal, setModal] = useState(null);
  const [willModalVanish, setWillModalVanish] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getOrders = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/orders`,
        headers: { Authorization: `Bearer ${customer.token}` },
      });
      console.log(response.data);
      setOrders(response.data);
    } catch (err) {
      console.log(err);
    }
  };
  const editOrder = () => {
    setModal(null);
    dispatch({ type: "TOGGLE_CART_VISIBILITY" });
  };
  const cancelOrder = async (orderId) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/orders/${orderId}`, {
        headers: { Authorization: `Bearer ${customer.token}` },
      });
      console.log(response.data.msg);
      setOrders(
        orders.map((order) => (order.id === orderId ? { ...order, status: "cancelled" } : order)),
      );
    } catch (err) {
      console.log("Something unexpected happened and the order could not be cancelled.");
    }
  };
  const closeModal = async () => {
    setWillModalVanish(true);
    setTimeout(() => {
      setModal(null);
      setWillModalVanish(false);
    }, 500);
  };

  useEffect(() => {
    if (customer) return getOrders();
    navigate("/login");
  }, [shoppingCart, customer]);

  return (
    <div>
      {modal && (
        <div className={`modal-order p-1 shadow ${willModalVanish ? "vanishes" : "appears"}`}>
          <div className="d-flex p-2 justify-content-between">
            <h2>Order #{modal.id}</h2>
            <span className="fs-3" style={{ cursor: "pointer" }} onClick={closeModal}>
              <i className="bi bi-x-lg"></i>
            </span>
          </div>
          <table className="table">
            <tr>
              <th>Product</th>
              <th>Unit cost</th>
              <th>Quantity</th>
            </tr>
            {modal.content.map((product) => (
              <tr key={product.id}>
                <td>{product.name}</td>
                <td>U$S {product.sellingPrice}</td>
                <td>{product.quantity}</td>
              </tr>
            ))}
          </table>
        </div>
      )}
      <Navbar />
      <section className="layout_padding">
        <div className="container">
          <h1>My orders:</h1>
          <div className="orders-list">
            {orders
              .filter((order) => order.content.length > 0)
              .map((order, index) => {
                const numberOfProducts = order.content.reduce(
                  (partialSum, product) => partialSum + product.quantity,
                  0,
                );
                const totalCost = order.content.reduce(
                  (partialCost, product) => partialCost + product.quantity * product.sellingPrice,
                  0,
                );
                return (
                  <div
                    className={`order ${index % 2 === 0 ? "even" : "odd"} p-2 row`}
                    key={order.id}
                  >
                    <div className="col-md-9">
                      <div className="d-flex justify-content-between">
                        <p>
                          <span className="fw-bold">Creation date: </span>
                          {format(new Date(order.createdAt), "P")}
                        </p>
                        <p>
                          <span className="fw-bold">Status: </span>
                          {order.status}
                        </p>
                        <p>
                          <span className="fw-bold">Size: </span>
                          {numberOfProducts} products{" "}
                          <span className="see-content text-muted" onClick={() => setModal(order)}>
                            (See content)
                          </span>
                        </p>
                      </div>
                      <p className="mb-0">
                        <span className="fw-bold">Shipping address: </span>
                        {order.shippingDetails ? order.shippingDetails.address : "[UNDEFINED]"}
                      </p>
                    </div>
                    <div className="col-md-3 d-flex justify-content-center align-items-center">
                      {order.status === "in-cart" && (
                        <span className="btn-order change-order text-center" onClick={editOrder}>
                          EDIT MY ORDER
                        </span>
                      )}
                      {(order.status === "paid" || order.status === "shipping") && (
                        <span
                          className="btn-order delete-order confirm-button"
                          onClick={() => cancelOrder(order.id)}
                        >
                          CANCEL THIS ORDER
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default MyOrders;
